// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as MarkdownImageExtended } from '../../../../../ui-v3/src/assets/icons/extended/markdown/markdown-image.svg?react';
import { createIcons } from '../../Icon';
const MarkdownImageIcon = /* @__PURE__ */ createIcons('MarkdownImage', {
    extended: MarkdownImageExtended
});
MarkdownImageIcon.supportedTypes = [
    'extended'
];
MarkdownImageIcon.category = 'markdown';
export default MarkdownImageIcon;
